// StartWorkButton.tsx
import React, { useState } from "react";
import { UniButton } from "../../../../../../@WUM/core/Elements";
import { clockTimingInterface } from "../../../../API/request/clockTimingInterface";
import { StartWork } from "../../../../API/response/worktimeclock";

interface StartWorkButtonProps {
    onSuccess?: (result: clockTimingInterface) => void;
}

const StartWorkButton = ({ onSuccess }: StartWorkButtonProps) => {
    const [loading, setLoading] = useState(false);

    const handleStart = async () => {
        setLoading(true);
        const result = await StartWork();
        setLoading(false);

        if (result) {
            localStorage.setItem("workStart", new Date().toISOString());
            onSuccess?.(result);
        }
    };

    return (
        <UniButton disabled={loading} onClick={handleStart} class={""} variant={"success"}>
            {loading ? "..." : "🟢 Kommen"}
        </UniButton>
    );
};

export default StartWorkButton;
